@if(loadingState$ | async; as loadingState) {
    <div class="preloader-wrapper backdrop">
        <img class="img-preloader" src="{{ mediaServer }}/zeta/common/preloader.png" alt="..." >
    </div>
}